import suuid from "short-unique-id";

export default {
  //* loadLists ---------------------------------------------------------------------------------------------------------------

  async loadLists({ rootGetters, commit }) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      resp_json = {};
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getList/all", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      // localStorage.setItem("lists", JSON.stringify(resp_json));
    }

    commit("setLists", resp_json);
    console.log(resp_json);
    return resp_json;
  },

  //* loadList ---------------------------------------------------------------------------------------------------------------

  async loadList({ rootGetters }, id) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var list = await fetch(base_address + "/getList/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (list.ok) {
      list = list.json();
    }
    return list;
  },

  //* loadMailjetCamp ---------------------------------------------------------------------------------------------------------------

  async loadMailjetCamp({ rootGetters }, id) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    const payload = {
      custCamp: id,
    };
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      resp_json = {};
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getCampaigns/synchMailjet", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
    }
    console.error(resp_json);
    return resp_json;
  },
  // update backend side
  async patchLists({ rootGetters }, payload) {
    // @payload needs the id of the contact and all the attributes needed
    const id = payload.idList;
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      data = payload;
    // otherwise the patch is not permitted
    delete data.idList;
    data = JSON.stringify(data);
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/editList/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* addList ---------------------------------------------------------------------------------------------------------------

  async addList({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/addlist", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* addListCsv ---------------------------------------------------------------------------------------------------------------

  async addListCsv({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/cv/api/newsletter/create-list", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* deleteList ---------------------------------------------------------------------------------------------------------------

  async deleteList({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var response = fetch(base_address + "/deleteList/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    await response;
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* deleteContactList ---------------------------------------------------------------------------------------------------------------

  async deleteContactList({ rootGetters }, { idLista, idContatto }) {
    // @payload needs the contact infos needed
    /*
			ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var response = fetch(base_address + "/deleteContactList/" + idLista, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify({ idContatto: idContatto }),
    }).catch((e) => console.log(e));
    await response;
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* addContactList ---------------------------------------------------------------------------------------------------------------

  async addContactList({ rootGetters }, { idLista, idContatti }) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/addContactList/" + idLista, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify({ idContatti: idContatti }),
    }).catch((e) => console.log(e));
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* sendMail ---------------------------------------------------------------------------------------------------------------

  async sendMail({ rootGetters, dispatch }, payload) {
    // @payload needs the contact infos needed
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];

    tok = "Bearer " + tok; // composition of the token

    //! recupero la configurazione

    var idConfig = "";
    var opzioniInvio = await dispatch(
      "settings/queryConfig",
      {
        group: "emailInvioPreventivi",
      },
      { root: true }
    );
    // console.log("🚀 ~ file: actions.js:301 ~ opzioniInvio:", opzioniInvio);

    if (opzioniInvio instanceof Array) {
      idConfig = opzioniInvio.length ? opzioniInvio[0]._id : null;
    } else {
      idConfig = opzioniInvio ? opzioniInvio._id : null;
    }

    payload.idConfig = idConfig;
    // console.log("🚀 ~ file: actions.js:1147 ~ sendEmailCV ~ payload:", payload);

    var uuid = null;
    //! non è una news letter
    if (!payload.isNewsletter) {
      //! non c'è già un uuid
      var exist = false;
      exist = payload.subj.indexOf("{");
      if (exist < 0) {
        //! require unique id for email

        var response = await fetch(base_address + "/getUUID", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true,
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            Authorization: tok,
          },
          mode: "cors", // no-cors, *cors, same-origin
          body: JSON.stringify(payload),
        });

        response = await response.json();
        uuid = response.UUID;

        //! updating the subject

        payload.subj = payload.subj + " - RIF.: {" + uuid + "} [CRM]";
      }
    }
    var response = await fetch(base_address + "/sendMail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    });
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
      // patch camping adding the email sent to the list
      if (!payload.isNewsletter) {
        //? se non esiste il client ID cerco il primo risultato buono tra i contatti
        if (!payload.clientID) {
          var cID = await dispatch(
            "clients/queryClients",
            {
              email: payload.list[0],
            },
            { root: true }
          );
          if (cID.length)
            payload.clientID = cID[0]._id ? cID[0]._id : undefined;
        }
        var clientID = payload.clientID || undefined;
        var data_traccia = {
          emails: payload.list,
          body: payload.html,
          object: payload.subj,
          client: clientID,
          isSent: true,
        };
        //! track the emails
        if (payload.linked_mails && payload.linked_mails != "") {
          data_traccia.linked_mails = payload.linked_mails;
        }
        if (payload.prev_replies) {
          data_traccia.prev_replies = payload.prev_replies;
        }
        await dispatch("mail/addTracciaMail", data_traccia, {
          root: true,
        });

        var response = await fetch(base_address + "/markUUID/" + uuid, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true,
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            Authorization: tok,
          },
          mode: "cors", // no-cors, *cors, same-origin
        });
        // console.log(response);
      }
    }
    return ret_val;
  },

  //* sendNewsletter ---------------------------------------------------------------------------------------------------------------

  async sendNewsletter({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/sendNewsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    });
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
      // patch camping adding the email sent to the list
    }
    return ret_val;
  },

  //* sendMailConfirm ---------------------------------------------------------------------------------------------------------------

  async sendMailConfirm({ rootGetters, dispatch }, payload) {
    // console.log(payload);
    // @payload needs the contact infos needed
    var ret_val = 400,
      base_address = rootGetters["settings/getBaseAddress"];

    var idConfig = "";
    var opzioniInvio = await dispatch(
      "settings/queryConfigNoAuth",
      {
        group: "emailInvioPreventivi",
        camping: payload.camping,
      },
      { root: true }
    );
    // console.log("🚀 ~ file: actions.js:301 ~ opzioniInvio:", opzioniInvio);

    if (opzioniInvio instanceof Array) {
      idConfig = opzioniInvio.length ? opzioniInvio[0]._id : null;
    } else {
      idConfig = opzioniInvio ? opzioniInvio._id : null;
    }

    payload.idConfig = idConfig;
    //! non è una news letter
    if (!payload.isNewsletter) {
      //! non c'è già un uuid
      var exist = false;
      exist = payload.subj.indexOf("{");
      if (exist < 0) {
        const id_ = new suuid({ dictionary: "hex" });
        payload.subj =
          payload.subj + " - RIF.: {" + id_.randomUUID(6) + "} [CRM]";
      }
    }
    const response = await fetch(base_address + "/sendMailConfirm", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    });
    if (response.ok) {
      ret_val = 200; // means ok, all right (http protocol)
      // patch camping adding the email sent to the list
      if (!payload.isNewsletter) {
        //? se non esiste il client ID cerco il primo risultato buono tra i contatti
        if (!payload.clientID) {
          var cID = await dispatch(
            "clients/queryClients",
            {
              email: payload.list[0],
            },
            { root: true }
          );
          if (cID.length)
            payload.clientID = cID[0]._id ? cID[0]._id : undefined;
        }
        var clientID = payload.clientID || undefined;
        var data_traccia = {
          emails: payload.list,
          body: payload.html,
          object: payload.subj,
          client: clientID,
          isSent: true,
        };
        //! track the emails
        if (payload.linked_mails && payload.linked_mails != "") {
          data_traccia.linked_mails = payload.linked_mails;
        }
        if (payload.prev_replies) {
          data_traccia.prev_replies = payload.prev_replies;
        }
        await dispatch("mail/addTracciaMail", data_traccia, {
          root: true,
        });
      }
    }
    return ret_val;
  },

  //* salvaBozza ---------------------------------------------------------------------------------------------------------------

  async salvaBozza({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/addBozza", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* loadContactsLazy ---------------------------------------------------------------------------------------------------------------

  async loadContactsLazy({ rootGetters }, dati) {
    // load contacts from backend
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var id = dati.id;
    delete dati.id;
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/getListContact/lazy/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify(dati),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json;
    }
    return {};
  },

  //* patchBozza ---------------------------------------------------------------------------------------------------------------

  async patchBozza({ rootGetters }, payload) {
    // @payload needs the id of the contact and all the attributes needed
    const id = payload.idBozza;
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"],
      data = payload;
    // otherwise the patch is not permitted
    delete data.idBozza;
    data = JSON.stringify(data);
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/editBozza/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: data,
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* deleteBozza ---------------------------------------------------------------------------------------------------------------

  async deleteBozza({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/deleteBozza/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* salvaTemplate ---------------------------------------------------------------------------------------------------------------

  async salvaTemplate({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var resp = await fetch(base_address + "/addTemplate", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).catch((e) => console.log(e));
    if (resp.ok) {
      resp = await resp.json(); // means ok, all right (http protocol)
    }
    return resp;
  },

  //* patchTemplate ---------------------------------------------------------------------------------------------------------------

  async patchTemplate({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var idTemplate = payload.id;
    var data = {
      name: payload.name,
      html: payload.html,
      note: payload.note,
      images: payload.images,
    };
    if (payload.lang) {
      data.lang = payload.lang;
    }
    if (payload.isSollecito) {
      data.isSollecito = payload.isSollecito;
    }
    var response = await fetch(base_address + "/editTemplate/" + idTemplate, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(data),
    }).catch((e) => {
      console.log(e);
    });
    if (response.ok) {
      ret_val = await response.json(); // means ok, all right (http protocol)
    }
    return ret_val;
  },

  //* getTemplates ---------------------------------------------------------------------------------------------------------------

  async getTemplates({ rootGetters }) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/getTemplate/all", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => {
      console.log(e);
    });
    if (response.ok) {
      response = await response.json();
    } else {
      response = [];
    }
    return response;
  },

  //* addImage ---------------------------------------------------------------------------------------------------------------

  async addImage({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/addImage", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then(async (response) => {
      if (response.ok) {
        ret_val = await response.json(); // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getImage ---------------------------------------------------------------------------------------------------------------

  async getImage({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = {},
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/getImage/" + id, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then(async (response) => {
      if (response.ok) {
        ret_val = await response.json(); // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* loadAllImagesTipologie ---------------------------------------------------------------------------------------------------------------

  async loadAllImagesTipologie({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];

    if (!id) {
      var user = await rootGetters["auth/getUser"];
      id = JSON.parse(user);
      id = id.camping;
    }
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/imageQuery/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify({}),
    }).then(async (response) => {
      if (response.ok) {
        ret_val = await response.json(); // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* deleteImg ---------------------------------------------------------------------------------------------------------------

  async deleteImg({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/deleteImage/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getStats ---------------------------------------------------------------------------------------------------------------

  async getStats({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/getCampaignsStats/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => {
      console.log(e);
    });

    if (response.ok) {
      response = await response.json();
    } else {
      response = [];
    }
    return response;
  },

  //* deleteTemplate ---------------------------------------------------------------------------------------------------------------

  async deleteTemplate({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/deleteTemplate/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* templateQuery ---------------------------------------------------------------------------------------------------------------

  async templateQuery({ rootGetters }, data) {
    // load quotes from backend
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    var response = await fetch(base_address + "/templateQuery", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(data),
    }).catch((e) => console.log(e));
    response = await response.json();
    return response;
  },

  //* getImageQuery ---------------------------------------------------------------------------------------------------------------

  async getImageQuery({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = {},
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var idTipologia = id.idTipologia;
    var nTipologia = id.nTipologia;
    await fetch(
      base_address + "/getImageQuery/" + idTipologia + "/" + nTipologia,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }
    ).then(async (response) => {
      if (response.ok) {
        ret_val = await response.json(); // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* addDescription ---------------------------------------------------------------------------------------------------------------

  async addDescription({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			!ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token

    await fetch(base_address + "/addDescription", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then(async (response) => {
      if (response.ok) {
        ret_val = await response.json(); // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getDescription ---------------------------------------------------------------------------------------------------------------

  async getDescription({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = {},
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var idTipologia = id.idTipologia;
    var idLingua = id.idLingua;
    var idCamp = id.idCamp;
    await fetch(
      base_address +
        "/getDescription/" +
        idTipologia +
        "/" +
        idLingua +
        "/" +
        idCamp,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }
    ).then(async (response) => {
      if (response.ok) {
        try {
          ret_val = await response.json(); // means ok, all right (http protocol)
        } catch (e) {
          console.log(e);
        }
      }
    });
    return ret_val;
  },

  //* getAllDescription ---------------------------------------------------------------------------------------------------------------

  async getAllDescription({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = {},
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var idTipologia = id.idTipologia;
    var idCamp = id.idCamping;
    await fetch(
      base_address + "/getAllDescription/" + idTipologia + "/" + idCamp,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }
    ).then(async (response) => {
      if (response.ok) {
        ret_val = await response.json(); // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* deleteDescription ---------------------------------------------------------------------------------------------------------------

  async deleteDescription({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var idTipologia = id.idTipologia;
    var idLingua = id.idLingua;
    await fetch(
      base_address + "/deleteDescription/" + idTipologia + "/" + idLingua,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }
    ).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* sendEmailCV ---------------------------------------------------------------------------------------------------------------

  async sendEmailCV({ rootGetters, dispatch }, payload) {
    // @payload needs the contact infos needed
    //! routine to obtain camping name
    var User = rootGetters["auth/getUser"];
    if ((typeof User).toLowerCase() == "string") {
      User = JSON.parse(User);
    }

    var base_address = rootGetters["settings/getBaseAddress"];

    var tok = rootGetters["auth/getToken"],
      // otherwise the patch is not permitted
      tok = "Bearer " + tok; // composition of the token

    var uuid = null;

    //! end of routine
    if (!payload.isNewsletter) {
      //! non c'è già un uuid
      var exist = false;
      exist = payload.subj.indexOf("{");
      if (exist < 0) {
        //! require unique id for email
        var response = await fetch(base_address + "/getUUID", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Credentials": true,
            "Access-Control-Allow-Origin": "*",
            Accept: "application/json",
            Authorization: tok,
          },
          mode: "cors", // no-cors, *cors, same-origin
          body: JSON.stringify(payload),
        });

        response = await response.json();
        uuid = response.UUID;

        //! updating the subject

        payload.subj = payload.subj + " - RIF.: {" + uuid + "} [CRM]";
      }
    }
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/sendMailCV", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then(async (response) => {
      ret_val = await response.json();
      console.log(ret_val);
      // if (response.ok) {
      //   ret_val = 200; // means ok, all right (http protocol)
      // } else {
      //   ret_val = 400;
      // }
      //ret_val = response;
    });
    // payload.html = payload.html.replace("getTrackPixel", "notGetTrackPixel");
    var data_traccia = {
      emails: payload.list,
      body: payload.html.replace("getTrackPixel", "notGetTrackPixel"),
      object: payload.subj,
      idEmail: payload.idEmail,
      client: undefined,
      isSent: true,
      meta: {
        operatore: payload.operatore,
        emailCV: payload.IsCVMail, //! attenzione a questo parametro
        cliente: payload.cliente,
        tag: payload.tag,
      },
    };
    if (ret_val.responseCode == 200)
      await dispatch("mail/addTracciaMail", data_traccia, { root: true });
    return ret_val;
  },

  //* sendEmail ---------------------------------------------------------------------------------------------------------------

  async sendEmail({ rootGetters, dispatch }, payload) {
    // @payload needs the contact infos needed
    /*
            ! ATTENTION:
            commit to store not added !
          */
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/sendMail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    var data_traccia = {
      emails: payload.list,
      body: payload.html,
      object: payload.subj,
      client: undefined,
      isSent: true,
      meta: {
        operatore: payload.operatore,
        emailCV: true,
        cliente: payload.cliente,
        tag: payload.tag,
      },
    };
    if (ret_val == 200)
      await dispatch("mail/addTracciaMail", data_traccia, { root: true });
    return ret_val;
  },

  //* newsletterSubscription ---------------------------------------------------------------------------------------------------------------

  async newsletterSubscription({ rootGetters, dispatch }, payload) {
    // @payload needs the contact infos needed
    /*
            ! ATTENTION:
            commit to store not added !
          */
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/newsletterSubscription", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* sendEmailGmail ---------------------------------------------------------------------------------------------------------------

  async sendEmailGmail({ rootGetters, dispatch }, payload) {
    // @payload needs the contact infos needed
    await fetch(base_address + "/gmailCrm/getAccessToken", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    await fetch(base_address + "/gmail/sendEmail", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    var data_traccia = {
      emails: payload.list,
      body: payload.html,
      object: payload.subj,
      client: undefined,
      isSent: true,
      meta: {
        operatore: payload.operatore,
        emailCV: true,
        cliente: payload.cliente,
        tag: payload.tag,
      },
    };
    if (ret_val == 200)
      await dispatch("mail/addTracciaMail", data_traccia, { root: true });
    return ret_val;
  },

  //* loadImagesLazy ---------------------------------------------------------------------------------------------------------------

  async loadImagesLazy({ rootGetters }, dati) {
    // load contacts from backend
    /*
				! ATTENTION:
				commit to store not added !
			*/

    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/imageManager/lazy", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify(dati),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      resp_json = await response.json();
      return resp_json;
    }
    return {};
  },

  //* getImageByID ---------------------------------------------------------------------------------------------------------------

  async getImageByID({ rootGetters }, id) {
    // load contacts from backend
    /*
				! ATTENTION:
				commit to store not added !
			*/

    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(
      base_address + "/imageManager/getImageObject/" + id,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }
    ).catch((e) => console.log(e));

    if (response.ok) {
      resp_json = await response.json();
      return resp_json;
    }
    return {};
  },

  //* patchImage ---------------------------------------------------------------------------------------------------------------

  async patchImage({ rootGetters }, payload) {
    // load contacts from backend
    /*
				! ATTENTION:
				commit to store not added !
			*/
    var id = payload._id;
    delete payload._id;
    var resp_json = "",
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    tok = "Bearer " + tok; // composition of the token
    const response = await fetch(base_address + "/patchImage/" + id, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      body: JSON.stringify(payload),
      mode: "cors", // no-cors, *cors, same-origin
    }).catch((e) => console.log(e));
    if (response.ok) {
      return resp_json;
    }
    return {};
  },

  //* addTypologyCategory ---------------------------------------------------------------------------------------------------------------

  async addTypologyCategory({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			!ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token

    await fetch(base_address + "/addTypologyCategory", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
      body: JSON.stringify(payload),
    }).then(async (response) => {
      if (response.ok) {
        ret_val = await response.json(); // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getDescription ---------------------------------------------------------------------------------------------------------------

  async getTypologyCategory({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = {},
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var idTipologia = id.idTipologia;
    var idCamp = id.idCamp;
    await fetch(
      base_address + "/getTypologyCategory/" + idTipologia + "/" + idCamp,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
      }
    ).then(async (response) => {
      if (response.ok) {
        ret_val = await response.json(); // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getAllTypologyCategory ---------------------------------------------------------------------------------------------------------------

  async getAllTypologyCategory({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = {},
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var idCamp = id.idCamp;
    await fetch(base_address + "/getAllTypologyCategory/" + idCamp, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then(async (response) => {
      if (response.ok) {
        ret_val = await response.json(); // means ok, all right (http protocol)
      }
    });
    return ret_val.categories;
  },

  //* deleteDescription ---------------------------------------------------------------------------------------------------------------

  async deleteTypologyCategory({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var ret_val = 400,
      tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token
    var idTipologia = id.idTipologia;
    await fetch(base_address + "/deleteTypologyCategory/" + idTipologia, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "*",
        Accept: "application/json",
        Authorization: tok,
      },
      mode: "cors", // no-cors, *cors, same-origin
    }).then((response) => {
      if (response.ok) {
        ret_val = 200; // means ok, all right (http protocol)
      }
    });
    return ret_val;
  },

  //* getStatsLinks ---------------------------------------------------------------------------------------------------------------

  async getStatsLinks({ rootGetters }, id) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token

    const body = {
      custCamp: id,
    };
    var response = await fetch(
      base_address + "/getCampaigns/synchMailjet/linkStats",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
        body: JSON.stringify(body),
      }
    ).catch((e) => {
      console.log(e);
    });

    if (response.ok) {
      response = await response.json();
    } else {
      response = [];
    }
    return response;
  },
  //* getDatiGrafico ---------------------------------------------------------------------------------------------------------------

  async getDatiGrafico({ rootGetters }, payload) {
    // @payload needs the contact infos needed
    /*
			! ATTENTION:
			commit to store not added !
		*/
    var tok = rootGetters["auth/getToken"],
      base_address = rootGetters["settings/getBaseAddress"];
    // otherwise the patch is not permitted
    tok = "Bearer " + tok; // composition of the token

    var response = await fetch(
      base_address + "/getCampaigns/synchMailjet/realtime",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Access-Control-Allow-Credentials": true,
          "Access-Control-Allow-Origin": "*",
          Accept: "application/json",
          Authorization: tok,
        },
        mode: "cors", // no-cors, *cors, same-origin
        body: JSON.stringify(payload),
      }
    ).catch((e) => {
      console.log(e);
    });

    if (response.ok) {
      response = await response.json();
    } else {
      response = {
        error:
          'Stai cercando di visualizzare troppi dati, prova con un periodo più breve. Puoi visualizzare solo 100 giorni in modalità "Giorno", fino a 8 ore in modalità 5-min.',
      };
    }
    return response;
  },
};
